import { buildPrompt } from '@/ai/utils/promptBuilder'
import { sanitizeCardDescription } from '@/utils/sanitize'
import { systemMessages } from '@/ai/prompts/common/systemMessages'
import { getJsonOutputFormatting } from '@/ai/prompts/common/formatting'
import {
  diagramToJson,
  createUserMessage,
  createSystemMessage,
  getWorkflowBackgroundSections
} from '@/ai/utils/promptUtils'

export const buildCommentReplyPrompt = ({
  workflow,
  svgGraph,
  svgLanes,
  cardTypes,
  input
}) => {
  const messages = []

  messages.push(createSystemMessage(systemMessages.EVENT_MODELING_DDD_EXPERT))

  const promptSections = []

  const { workflow: currentDiagram, currentStep } = workflow.eventsJson?.length
    ? diagramToJson(input.node.id, workflow, svgGraph, svgLanes)
    : { workflow: [], currentStep: undefined }
  const workflowBackgroundSections = getWorkflowBackgroundSections(workflow, currentDiagram, cardTypes)
  const card = input.node.requirementsJson.find((card) => card.id === input.requirementId)
  const currentStepObject = currentDiagram[currentStep - 1]

  promptSections.push(...workflowBackgroundSections)

  promptSections.push({
    title: 'Request',
    content: `Answer this question: ${sanitizeCardDescription(input.text)}`,
    spacingAfter: 1
  })

  promptSections.push({
    content: `
      The Request above specifically refers to step ${currentStep} (${currentStepObject.role} - ${currentStepObject.description})
      in the workflow and the meta data: ${card.cardType.title} "${card.description}".
    `,
    spacingAfter: 1
  })

  if (card.comments?.length > 1) {
    promptSections.push({
      content: 'Here you can see the question in the context of previous comments:',
      spacingAfter: 1
    })
    card.comments.forEach((comment, index) => {
      promptSections.push({
        content: `> ${sanitizeCardDescription(comment.text)}`,
        spacingAfter: index === card.comments.length - 1 ? 2 : 1
      })
    })
  }

  const example = { message: 'This is an example message' }

  promptSections.push({
    title: 'Formatting',
    flattenLines: false,
    content: getJsonOutputFormatting('message', JSON.stringify(example))
  })

  const userContent = buildPrompt(promptSections)
  messages.push(createUserMessage(userContent))

  return messages
}
